import GetCode from './GetCode.vue';

GetCode.install = (Vue) => {
  Vue.component(GetCode.name, GetCode);
};

export default GetCode;
